<template>
	<footer class="section wf-section">
		<div class="container footer w-container">
			<div class="w-layout-grid main-grid inner-padding-small">
				<div id="w-node-_079daf08-1fe5-f60c-84e0-72a07e063470-da75d367" class="grid-wrapper">
					<a :href="/dashboard/"> <img href="/dashboard" src="/img/icons/hyper-logo-white.svg" loading="lazy"
							alt="Hyper wash Stockholm logo" class="logo-footer hyper"></a>
					<div class="list-wrapper">
						<ul role="list" class="w-list-unstyled">
							<li>
								<h4 class="heading-small text-white">Bergkällavägen 39 G<br>192 79
									Sollentuna<br>Upplands Väsby<br>Infra City / Bredden<br>Stockholm</h4>
							</li>
							<li>
								<a href="tel:+468300005" class="link-footer">Tel:&nbsp;+468300005</a>
							</li>
							<li>
								<a href="mailto:info@hyperwash.se?subject=Mail%20Hyper%20wash"
									class="link-footer">info@hyperwash.se</a>
							</li>
						</ul>
					</div>
				</div>
				<div class="footer-inner g2">
					<div class="small-legal-text">© Hyperwash Nordic AB - 2022</div>
				</div>
				<div id="w-node-_079daf08-1fe5-f60c-84e0-72a07e06347e-da75d367" class="footer-inner socials">
					<div class="w-layout-grid grid-buttons social">
						<a href="#" class="link-icons center w-inline-block justifyself"><img
								src="/img/icons/ic-facebook-white.svg" loading="lazy" alt="Facebook icon svg"
								class="icon-social"></a>
						<a href="#" class="link-icons center w-inline-block"><img
								src="/img/icons/ic-instagram-white.svg" loading="lazy" alt="Instagram icon svg"
								class="icon-social"></a>
						<a href="#" class="link-icons center w-inline-block"><img src="/img/icons/ic-twitter-white.svg"
								loading="lazy" alt="Twitter icon svg" class="icon-social"></a>
						<a href="#" class="link-icons center w-inline-block"><img src="/img/icons/ic-linkedin-white.svg"
								loading="lazy" alt="Linkedin icon svg" class="icon-social"></a>
					</div>
				</div>
				<div id="w-node-_079daf08-1fe5-f60c-84e0-72a07e063488-da75d367" class="w-layout-grid inner-footer-nav">
					<div class="grid-wrapper hyperfooter"></div>
					<div class="grid-wrapper hyperfooter"></div>
					<div class="grid-wrapper hyperfooter">
						<ul role="list" class="w-list-unstyled">
							<li>
								<h4 class="heading-small text-white">Öppettider</h4>
							</li>
							<li>
								<div class="link-footer">Mån-Fre 08-17</div>
							</li>
							<li>
								<div class="link-footer">Lördag 10-17</div>
							</li>
							<li>
								<div class="link-footer">Söndag 10-17</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>
<script>
export default {
	name: 'Footer'
}
</script>

<style scoped>
.g2 {
	-ms-grid-column-span: 6;
	grid-column-end: 7;
	-ms-grid-column: 1;
	grid-column-start: 1;
	-ms-grid-row-span: 1;
	grid-row-end: 3;
	-ms-grid-row: 2;
	grid-row-start: 2;
	-ms-grid-column-align: start;
	justify-self: start;
	-ms-grid-row-align: center;
	align-self: center;
}

.justifyself {
	-ms-grid-column-align: center;
	justify-self: center;
}
@media screen and (max-width: 1024px) {
	.socials{
		display:none;
	}
}
@media screen and (max-width: 767px) {
	#w-node-_079daf08-1fe5-f60c-84e0-72a07e063470-da75d367{
		grid-column-end:6;
	}
}
</style>
